<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{'Notification Summary'|translate}}
                    <date-range-selector v-model="dateRange" class="ml-3" @change="handleDateChange()"></date-range-selector>
                    <v-spacer></v-spacer>
                    <v-btn class="accent elevation-4" @click="exportNotification">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{'Download'|translate}}
                    </v-btn>
                    <v-btn class="accent elevation-4" @click="markAllAsFixedDialog=true">
                        <v-icon small class="mr-2">fa-check</v-icon>
                        {{'Mark All as Fixed'|translate}}
                    </v-btn>
                    <v-btn class="accent elevation-4" @click="ackAllNotifs">
                        <v-icon small class="mr-2">fa-bell-slash</v-icon>
                        {{'Ack All'|translate}}
                    </v-btn>
                    <v-btn class="accent elevation-4" @click="unackAllNotifs">
                        <v-icon small class="mr-2">fa-bell</v-icon>
                        {{'Unack All'|translate}}
                    </v-btn>
                    <v-dialog v-model="markAllAsFixedDialog" max-width="600">
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{'Mark all '|translate}} {{items.length}} {{' matching notifications as fixed'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <p>{{'Note : Notifications that have maintenance records will not be altered.'|translate}}</p>
                                <v-text-field :label="'Optional Comment'|translate" autofocus v-model="markAllAsFixedComment" clearable></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" round @click="markAllAsFixed(markAllAsFixedComment)">
                                    <v-icon class="mr-2">fa-check</v-icon>
                                    {{'Confirm'|translate}}
                                </v-btn>
                                <v-btn class="accent" round @click="markAllAsFixedDialog = false">
                                    {{'Cancel'|translate}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div style="width:100%; background-color: rgb(240,240,240)">
                            <v-btn round color="primary" dark v-for="(value,facet) in activeFacets"  v-bind:key="facet" >
                                {{facets[facet]}}
                                <v-icon small class="ml-2 mr-2" v-if="value.startsWith('NOT ')" @click="invertFacet(facet)">fa-not-equal</v-icon>
                                <v-icon small class="ml-2 mr-2" v-if="!value.startsWith('NOT ')"  @click="invertFacet(facet)">fa-equals</v-icon>
                                <span v-if="value.startsWith('NOT ')">{{value.substr(4)}} </span>
                                <span v-if="!value.startsWith('NOT ')">{{value}} </span>
                                <v-icon class="ml-2" @click="clearFacet(facet)">fa-times-circle</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 v-for="facetGraph in facetGraphs" v-bind:key="facetGraph.facet" v-bind:class="[facetGraph['flex-class'], 'md4']" >
                        <div class="pl-3 pr-3 pt-3">
                            <v-autocomplete
                                    solo-inverted
                                    :items="facetOptions[facetGraph.facet]"
                                    :label="facetGraph.label"
                                    @change="selectFacet($event, facetGraph.facet)"
                            ></v-autocomplete>
                        </div>

                        <div class="pa-4">
                            <vue-plotly disable-responsive :data="facetGraph.data" :layout="facetGraph.layout" :options="{}" @click="handleClick"></vue-plotly>

                        </div>
                    </v-flex>
                    <v-flex xs12 class="pa-4">
                        <v-data-table
                                :headers="headers"
                                disable-initial-sort
                                :items="items"
                                :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        >
                            <template v-slot:items="props">
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.notification_id }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.title }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.equip }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" >{{ props.item.equipType }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" >{{ props.item.topic }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer" >{{ props.item.floor }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer caption">{{ props.item.description }}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{props.item.startDate}}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{props.item.endDate}}</td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="i in Array.from(new Set(props.item.maintenance_records.filter(x=>!x.is_fixed&&x.assigned_to&&x.assigned_to!=='').map(x=>x.assigned_to)))">{{ i }}</li>
                                    </ul>
                                </td>
                                <td class="text-xs-center">
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-badge
                                                    color="warning"
                                                    overlap
                                                >
                                                    <template v-slot:badge
                                                              v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                        <span>{{ props.item.maintenance_records.length }}</span>
                                                    </template>
                                                    <v-icon v-on="on" class="ml-2 mr-1" color="warning"
                                                            @click="callDialog(props.item)">fa-times
                                                    </v-icon>
                                                </v-badge>
                                            </v-badge>
                                        </template>
                                        <span>{{ props.item.maintenance_records.length }} {{ 'Maintenance Records'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" color="success" @click="callDialog(props.item)" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ 'Maintenance Completed'|translate }} </span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                fa-bell
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey"
                                                    @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                fa-bell-slash
                                            </v-icon>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                </td>
                                <td class="text-xs-left" style="min-width: 150px;">
                                    <v-icon small class="mr-2"
                                            @click="callDialog(props.item)">fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>{{ 'View chart'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="!props.item.muted">
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    @click="muteNotif(props.item.notification_id, true);props.item.muted=true;"
                                            >
                                                fa-volume-up
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Mute'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="props.item.muted">
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    @click="muteNotif(props.item.notification_id, false);props.item.muted=false;"
                                            >
                                                fa-volume-mute
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Un-Mute'|translate }} </span>
                                    </v-tooltip>


                                </td>

                            </template>
                        </v-data-table>
                        <v-dialog v-model="dialog" :max-width="showAllMRForEquipment ? null : 1200">
                            <v-card>
                                <v-card-title class="primary white--text title">
                                    {{ currentItem.title }}
                                </v-card-title>
                                <v-card-text>
                                    <p class="headline">
                                        {{ 'Equipment'|translate }} : {{ currentItem.equip }}
                                    </p>
                                    <p>
                                        {{ currentItem.description }}
                                    </p>
                                    <p>
                                        {{ 'Occured between'|translate }} <strong> {{ currentItem.startDate.replace('T', ' ') }}</strong>
                                        {{ 'and'|translate }}
                                        <strong>{{ currentItem.endDate.replace('T', ' ') }}</strong>
                                    </p>
                                </v-card-text>
                                <v-divider v-if="currentItem.recommendedActions"></v-divider>
                                <v-card-text v-if="currentItem.recommendedActions">
                                    <p class="headline">
                                        {{ 'Recommended Actions'|translate }}
                                    </p>
                                    <ul v-if="currentItem.recommendedActions">
                                        <li v-for="i in currentItem.recommendedActions.split('\n')">
                                            {{ i }}
                                        </li>
                                    </ul>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <p class="headline">
                                            {{ 'Maintenance Records'|translate }}
                                        </p>
                                        <v-spacer></v-spacer>
                                        <span style="width:300px;"><v-switch color="success" v-model="showAllMRForEquipment" class="pa-0 ma-0 pt-3 pl-2"
                                                                             :label="'Show All Maintenance Records'|translate"></v-switch> </span>

                                    </v-layout>
                                    <v-data-table
                                        v-if="currentItem.maintenance_records&&currentItem.maintenance_records.length>0"
                                        :headers="maintenanaceHeaders"
                                        :items="currentItem.maintenance_records"
                                        class="elevation-1"
                                    >
                                        <template v-slot:items="props">
                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                {{ props.item.maintenance_id }}
                                            </td>
                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                {{ props.item.maintenance_label }}
                                            </td>
                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                <v-icon v-if="props.item.is_fixed" color="success">fa-check</v-icon>
                                                <v-icon v-else color="warning">fa-times</v-icon>
                                            </td>

                                            <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                                                {{ props.item.assigned_to }}
                                            </td>
                                            <td class="cursor-as-pointer text-xs-left">{{ props.item.assigned_by }}</td>
                                            <td class="cursor-as-pointer text-xs-left">
                                                <span v-if="props.item.assigned_date&&props.item.assigned_date!=='NaT'">{{
                                                        props.item.assigned_date.substring(0, 10)
                                                    }}</span>
                                            </td>
                                            <td  class="cursor-as-pointer text-xs-left">
                                                <v-icon small @click="editMR(props.item)">fa-edit</v-icon>
                                            </td>

                                        </template>
                                        <template v-slot:no-data>
                                            <v-btn color="primary" @click="initialize">{{ 'Refresh'|translate }}</v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                                <v-card-text v-if="showAllMRForEquipment">
                                    <p class="headline">
                                        {{ 'All Maintenance Records for '|translate }} {{ currentItem.equip }}
                                    </p>
                                    <maintenance-record :equipment-filter="currentItem.equip" ></maintenance-record>
                                </v-card-text>
                                <v-card-actions>

                                    <v-btn class="primary ml-2 elevation-4e" @click="callMaintenanceDialog(currentItem)">
                                        <v-icon class="mr-2">fa-plus</v-icon>
                                        {{ 'New Maintenance Record'|translate }}
                                    </v-btn>
                                    <v-btn class="primary elevation-4" @click="jumpToLink(currentItem)">
                                        <v-icon class="mr-2">fa-chart-line</v-icon>
                                        {{ 'View Chart'|translate }}
                                    </v-btn>
                                    <v-btn class="primary elevation-4" @click="jumpToLinkNW(currentItem)">
                                        <v-icon class="mr-2">fa-chart-line</v-icon>
                                        {{ 'View Chart in New Tab'|translate }}
                                    </v-btn>
                                    <v-btn icon v-if="!currentItem.acknowledged"
                                           @click="trigger(currentItem.notification_id, currentItem.acknowledged);currentItem.acknowledged=true;">
                                        <v-icon color="warning">fa-bell</v-icon>
                                    </v-btn>
                                    <v-btn icon v-if="currentItem.acknowledged"
                                           @click="trigger(currentItem.notification_id, currentItem.acknowledged);currentItem.acknowledged=false;">
                                        <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn outline class="mr-2" @click="dialog = false">
                                        {{ 'Close'|translate }}
                                    </v-btn>
                                </v-card-actions>
                                <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"></fault-record-dialog>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getMaintenanceRecords, getNotification} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import FaultRecordDialog from '../components/FaultRecordDialog'
    import SeverityChip from '../components/SeverityChip'
import {deleteAnomalyDescription, putMaintenanceRecord, putNotification} from '../helper'
    import {exportCSV} from '../tocsv'
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    import _ from 'lodash'
import MaintenanceRecord from "./MaintenanceRecord.vue";

    export default {
        name: 'NotificationBreakdown',
        components: {MaintenanceRecord, VuePlotly,SeverityChip, FaultRecordDialog,DateRangeSelector},
        data() {
            return {
                activeFacets:{},
                facetOptions:{},
                dialog: false,
                showAllMRForEquipment:false,
                markAllAsFixedDialog:false,
                markAllAsFixedComment:null,
                items:null,
                maintenanceDialog: false,
                maintenanaceHeaders: [
                    {
                        text: this.$options.filters.translate('ID'),
                        align: 'left',
                        sortable: true,
                        value: 'maintenance_id'
                    },
                    {
                        text: this.$options.filters.translate('Fault'),
                        align: 'left',
                        sortable: true,
                        value: 'maintenance_label'
                    },
                    { text: this.$options.filters.translate('Fixed'), value: 'is_fixed' },
                    { text: this.$options.filters.translate('Assigned to'), value: 'assigned_to' },
                    { text: this.$options.filters.translate('Assigned by'), value: 'assigned_by' },
                    { text: this.$options.filters.translate('Assigned date'), value: 'assigned_date' },
                    { text: this.$options.filters.translate('Actions'), sortable: false},
                ],
                maintenanceItem: null,
                dateRange:  {start:moment().subtract(30, "days").format("YYYY-MM-DD"),end:moment().format("YYYY-MM-DD")},
                search: '',
                facets: {
                    "floor": this.$options.filters.translate("Floor"),
                    "equipment_name": this.$options.filters.translate("Equipment"),
                    "severity": this.$options.filters.translate("Severity"),
                    "equipment_type": this.$options.filters.translate("Equipment Type"),
                    "title": this.$options.filters.translate("Issue"),
                    "topic": this.$options.filters.translate("Topic"),
                    "ack_status": this.$options.filters.translate("Acknowledged"),
                    "fixed_status": this.$options.filters.translate("Maintenance"),
                },
                currentItem: {
                    icon: 'fa-bell',
                    title: 'Condenser Cleaning Required in Chiller 1',
                    equip: 'Chiller 1',
                    startDate: '',
                    endDate: '',
                    to: {
                        path: '/sensors',
                        query: {
                            onOnly: true,
                            variableX: 'Cond_Approach',
                            variableY: 'Cond_Approach',
                            rangeStart: '2018-01-01',
                            rangeEnd: '2018-06-30',
                            equipment: 'Chiller 1'
                        }
                    },
                    description: "Condenser Approach High in Chiller 1",
                    recommendedActions: [
                        'Clean Condenser Tubes',
                        'Check Condenser Water Pumps',
                    ].join('\n')
                },
                facetGraphs:[],
                loading: true,
                rawNotifs:null,
                rawMRs:null,
                notifs:null,
            }
        },
        computed: {
            username () {
                if (this.$store.state.userStore.user) {
                    return this.$store.state.userStore.user.content.user_name
                }
                return null;
            },
            headers() {
                    return [
                        {
                            text: this.$options.filters.translate('ID'),
                            align: 'left',
                            sortable: true,
                            value: 'notification_id'
                        },
                        {
                            text: this.$options.filters.translate('Alerts'),
                            align: 'left',
                            sortable: true,
                            value: 'title'
                        },
                        {text: this.$options.filters.translate('Equipment'), value: 'equip'},
                        {text: this.$options.filters.translate('Equipment Type'), value: 'equipType',sortable: true},
                        {text: this.$options.filters.translate('Topic'), value: 'topic',sortable: true},
                        {text: this.$options.filters.translate('Floor'), value: 'floor',sortable: true},
                        {text: this.$options.filters.translate('Description'), value: 'description'},
                        {text: this.$options.filters.translate('Start Date'), value: 'startDate'},
                        {text: this.$options.filters.translate('End Date'), value: 'endDate'},
                        {text: this.$options.filters.translate('Severity'), value: 'severity'},
                        {text: this.$options.filters.translate('Assigned to'), value: 'acknowledged'},
                        {text: this.$options.filters.translate('Fixed'), value: 'acknowledged'},
                        {text: this.$options.filters.translate('Acknowledged'), value: 'acknowledged'},
                        {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false}
                    ]
            }
        },
        methods: {
            editMR(item){
                this.maintenanceItem=item
                this.maintenanceDialog=true
            },
            jumpToLinkNW(item) {
                let output=this.getItemUrl(item)
                if (process.env.VUE_APP_SINGLE_WINDOW_MODE){
                    this.$router.push(output)
                } else {
                    if (item.to&&item.to.external_domain){
                        window.open(item.to.external_domain+this.$router.resolve(output).href)
                    } else {
                        window.open(this.$router.resolve(output).href)
                    }
                }
            },
            selectFacet(event,facet){
                this.activeFacets[facet]=event
                this.updateQueryString()
                this.refineNotifs()
            },
            handleDateChange(){
                this.updateQueryString()
                this.getData()
            },
            updateQueryString () {
                if(this.$router.currentRoute.name==="notification-breakdown"){
                    let filters={...this.activeFacets}
                    filters.rangeStart=this.dateRange.start
                    filters.rangeEnd=this.dateRange.end
                    this.$router.replace({
                        path: '/notification-breakdown',
                        query: filters
                    }).catch(err => {})
                }
            },
            async trigger(id, state) {
                await putNotification(
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'notification_id': id,
                        'show_flag': state
                    }
                )
            },
            async muteNotif(id, state) {
                await putNotification(
                    {
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'notification_id': id,
                        'mute_notif': state
                    }
                )
            },
            async markAllAsFixed(comment){
                let cleanedItems=JSON.parse(JSON.stringify(this.items))
                for (let item of cleanedItems){
                    if (!item.maintenance_records||item.maintenance_records.length===0){
                        let newMR=this.getMaintenanceItem(item)
                        newMR.equipment_name=item['equip']
                        newMR.is_fixed=true
                        newMR.comments=[
                            {
                                "text": this.username+this.$options.filters.translate(" fixed this"),
                                "time": moment().format('YYYY-MM-DD HH:mm:ss'),
                                "user": this.username
                            }
                        ]
                        if (comment&&comment!==""){
                            newMR.comments.push({
                                "text": comment,
                                "time": moment().format('YYYY-MM-DD HH:mm:ss'),
                                "user": this.username
                            })
                        }
                        await putMaintenanceRecord(
                            newMR
                        )
                    }
                }
                this.markAllAsFixedDialog=false
                await this.getData()
            },
            async ackAllNotifs(){
                if (confirm(this.$options.filters.translate('Are you sure you want to ack all ')+this.items.length+this.$options.filters.translate(' matching notifications?'))) {
                    for (let item of this.items){
                        if (!item.acknowledged){
                            await this.trigger(item.notification_id,item.acknowledged)
                        }
                    }
                    await this.getData()
                }
            },
            async unackAllNotifs(){
                if (confirm(this.$options.filters.translate('Are you sure you want to unack all ')+this.items.length+this.$options.filters.translate(' matching notifications?'))) {
                    for (let item of this.items){
                        if (item.acknowledged){
                            await this.trigger(item.notification_id,item.acknowledged)
                        }
                    }
                    await this.getData()
                }
            },
            exportNotification() {
                let exportables=[]
                let cleanedItems=JSON.parse(JSON.stringify(this.items))
                for (let item of cleanedItems){
                    item.url= item.to&&item.to.external_domain ? item.to.external_domain+this.$router.resolve(this.getItemUrl(item)).href : window.location.origin+this.$router.resolve(this.getItemUrl(item)).href
                    delete(item.to)
                    delete(item.icon)
                    delete(item.maintenance_records)
                    let newitem={
                        ID: item.notification_id,
                        Alerts: item.title,
                        Equipment: item.equip,
                        "Equipment Type": item.equipType,
                        Topic: item.topic,
                        Floor: item.floor,
                        Description: item.description,
                        "Start Date": item.startDate,
                        "End Date": item.endDate,
                        Severity: item.severity,
                        Acknowledged:item.acknowledged ? "Yes" : "No",
                        URL: item.url,
                        "Alert Type": item.alertType,
                        "Recommended Actions": item.recommendedActions,
                    }
                    if (!newitem["Recommended Actions"]) {
                        delete (newitem["Recommended Actions"])
                    }
                    exportables.push(newitem)
                }
                exportCSV(exportables)
            },
            getMaintenanceItem(item) {
                let itemUrlObj=this.getItemUrl(item)
                return {
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    equipment: item['equip'],
                    maintenance_date_from: item['startDate'],
                    maintenance_date_to: item['endDate'],
                    severity: item['severity'],
                    maintenance_text: this.$options.filters.translate('Recommended Actions:')+' \n\n' + item['recommendedActions'],
                    maintenance_label: item['title'],
                    url: this.$router.resolve(itemUrlObj).href,
                    notification_id: item['notification_id'],
                    is_fixed: false,
                    maintenance_id: null
                }
            },
            callMaintenanceDialog(item, dialogOpen = true) {
                this.maintenanceItem = this.getMaintenanceItem(item)
                this.maintenanceDialog = dialogOpen
            },
            callDialog(item) {
                this.dialog = true
                this.currentItem = item
            },
            getItemUrl(item){
                let output = null;
                if (item.title.substring(0,7) === "Anomaly") {
                    output = {
                        path: '/modelsummary',
                        query: {
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipment: item.equip
                        }
                    }
                } else if (item.topic==="equipment health"){
                    output = {
                        path: '/equipment-health',
                        query: {
                            equipment: item.equip,
                        }
                    }
                }else {
                    output = {
                        path: '/fault-analysis',
                        query: {
                            relevantVariables: item.to.query.variableX,
                            faultName: item.title,
                            faultDesc: item.description,
                            rangeStart: item.to.query.rangeStart,
                            rangeEnd: item.to.query.rangeEnd,
                            equipmentName: item.equip,
                            nId:item.notification_id,
                            nTopic:item.topic,
                            nOct:item.occurredTimes
                        }
                    }
                }
                return output
            },
            jumpToLink(item) {
                let output=this.getItemUrl(item)
                if (item.to&&item.to.external_domain){
                    window.open(item.to.external_domain+this.$router.resolve(output).href)
                } else {
                    this.$router.push(output)
                }
                // this.$store.dispatch('updateMaintenanceItem', this.getMaintenanceItem(item))
                // this.$router.push(item.to)
            },
            jumpToMR(item) {
                let output={
                    path:"/maintenancerecord",
                    query:{
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                    }
                }
                if (item.to&&item.to.external_domain){
                    window.open(item.to.external_domain+this.$router.resolve(output).href)
                } else {
                    this.$router.push(output)
                }

            },
            handleClick(data){
                let facet=data.points[0].fullData.name
                let value=data.points[0].y
                this.activeFacets[facet]=value
                this.updateQueryString()
                this.refineNotifs()
            },
            clearFacet(facet){
                delete(this.activeFacets[facet])
                this.updateQueryString()
                this.refineNotifs()
            },
            invertFacet(facet){
                if(this.activeFacets[facet].startsWith("NOT ")){
                    this.activeFacets[facet]=this.activeFacets[facet].substr(4)
                } else {
                    this.activeFacets[facet]="NOT "+this.activeFacets[facet]
                }
                this.updateQueryString()
                this.refineNotifs()
            },
            getData() {
                let me = this;
                me.loading = true
                let promises=[getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:[this.dateRange.start,moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59"],
                }), getMaintenanceRecords({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:{start:this.dateRange.start,end:moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59"}
                })]
                Promise.all(promises).then(function(responses) {
                    let notifs=responses[0].result
                    for (let notif of notifs){
                        notif.maintenance_records=responses[1].result.filter(x=>x.notification_id&&x.notification_id===notif['notification_id'])
                        notif["ack_status"]=notif.acknowledged ? "acknowledged" : "unacknowledged"
                        notif["fixed_status"]="pending"
                        if (notif.maintenance_records.length>0){
                            notif["fixed_status"]=notif.maintenance_records.filter(x=>!x.is_fixed).length===0 ? "fixed" : "in progress"
                        }
                    }
                    me.rawNotifs=notifs
                    me.rawMRs=responses[1].result
                    me.refineNotifs()
                })
            },
            refineNotifs(){
                let me=this
                me.loading = true
                let notifs=[...me.rawNotifs]
                for (let activeFacet in me.activeFacets){
                    if((activeFacet==="floor"||activeFacet==="topic")&&me.activeFacets[activeFacet].startsWith("NOT ")){
                        notifs=notifs.filter(x=>!x[activeFacet].startsWith(me.activeFacets[activeFacet].substr(4)))
                    } else if(activeFacet==="floor"||activeFacet==="topic"){
                        notifs=notifs.filter(x=>x[activeFacet].startsWith(me.activeFacets[activeFacet]))
                    } else if (me.activeFacets[activeFacet].startsWith("NOT ")){
                        notifs=notifs.filter(x=>x[activeFacet]!==me.activeFacets[activeFacet].substr(4))
                    } else {
                        notifs=notifs.filter(x=>x[activeFacet]===me.activeFacets[activeFacet])
                    }
                }
                let facetGraphs=[]
                let facetOptions={}
                for (let facet in me.facets){
                    if(me.activeFacets[facet]&&facet!=="floor"&&facet!=="topic"){
                        continue
                    }
                    let facetObj={}
                    if (facet==="fixed_status"){
                        facetObj={fixed:0,"in progress":0,pending:0}
                    }
                    for (let notif of notifs){
                        if(facet==="floor"||facet==="topic"){
                            if(notif[facet]&&notif[facet]!==""){
                                let subfacets=notif[facet].split(">")
                                if(subfacets.length>1){

                                        let prev = [...subfacets]
                                        subfacets = subfacets.map((value, index) => {
                                            if (index === 0) {
                                                return value
                                            } else {
                                                return (prev.slice(0, index).join(">") + ">" + value)
                                            }
                                        })

                                }
                                for (let subfacet of subfacets){
                                    if(subfacet!==me.activeFacets[facet]&&subfacet!=="NOT "+me.activeFacets[facet]){
                                        if (!facetObj[subfacet]) {
                                            facetObj[subfacet] = 1;
                                        } else {
                                            facetObj[subfacet] += 1;
                                        }
                                    }
                                }
                            }
                        } else {
                            if (!facetObj[notif[facet]]) {
                                facetObj[notif[facet]] = 1;
                            } else {
                                facetObj[notif[facet]] += 1;
                            }
                        }
                    }
                    if(Object.keys(facetObj).length<=1&&facet!=="fixed_status"){
                        continue
                    }
                    let sorted = Object.keys(facetObj).sort(function(a,b){return facetObj[b]-facetObj[a]})
                    facetOptions[facet]=[...sorted];
                    if((facet==="floor"||facet==="topic")&&!me.activeFacets[facet]){
                        sorted=sorted.filter(x=>x.indexOf('>')<0)
                    }
                    let top10=sorted.slice(0,10);
                    let top10Scores=[]
                    for(let top of top10){
                        top10Scores.push(facetObj[top])
                    }
                    let x =top10Scores.reverse()
                    let y =top10.reverse()
                    let facetDef={
                        "facet":facet,
                        "label":me.facets[facet],
                        "data":[{
                            type: 'bar',
                            name:facet,
                            x: x,
                            y: y,
                            text:x,
                            textposition:'auto',
                            orientation: 'h',
                            hoverinfo:'none'
                        }],
                        "layout":{
                            title:"",
                            margin:{
                                l: 50,
                                r: 50,
                                t: 30,
                                pad: 1
                            },
                            xaxis: {'automargin': true,'tickformat':',d'},
                            yaxis: {'automargin': true},
                        }
                    }
                    if(facet=='title'){
                        facetDef['flex-class']='md8'
                        facetDef.layout.margin.l=500
                    } else {
                        facetDef.layout.margin.l=300
                    }

                    facetGraphs.push(facetDef)
                }
                me.facetOptions=facetOptions
                let items=[]
                for (let i in notifs) {
                    items.push({
                        icon: 'fa-bell',
                        alertType: notifs[i]['model'],
                        title: notifs[i]['title'],
                        equip: notifs[i]['equipment_name'],
                        equipType: notifs[i]['equipment_type'],
                        floor: notifs[i]['floor'],
                        startDate: notifs[i]['start_date'],
                        endDate: notifs[i]['end_date'],
                        topic: notifs[i]['topic'],
                        occurredTimes: notifs[i]['occurred_times'],
                        to: notifs[i]['to'],
                        description: notifs[i]['description'],
                        recommendedActions: notifs[i]['recommended_actions'],
                        severity: notifs[i]['severity'],
                        notification_id: notifs[i]['notification_id'],
                        acknowledged: notifs[i]['acknowledged'],
                        maintenance_records: notifs[i]['maintenance_records'],
                        ack_status: notifs[i]['ack_status'],
                        fixed_status: notifs[i]['fixed_status'],
                        muted: notifs[i]['muted'],
                    })
                }
                me.items= _.sortBy(items, ['startDate']).reverse()
                me.facetGraphs=facetGraphs
                me.loading = false
            }
        },
        mounted() {

            this.getData();
        },

        beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
                delete(preconf.rangeStart)
                delete(preconf.rangeEnd)
            } else if(maxDate){
                this.dateRange={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
            }
            if(Object.keys(preconf).length>0){
                this.activeFacets=preconf
            }
        }


    }
</script>
